import { useModelService } from "@shared/services/api/hooks/useModelService";
import UserBasedPaymentMethodRepository from "../repositories/UserBasedPaymentMethodRepository";

const useUserBasedPaymentMethodService = () => {
  const repository = new UserBasedPaymentMethodRepository();

  // Extract the necessary hooks from useModelService
  const modelService = useModelService(repository);

  return {
    ...modelService,
  };
};

export default useUserBasedPaymentMethodService;
